import * as React from "react"

import { cn } from "../lib/utils"
import { controlBase, controlDisabled, controlFocus } from "../styles/recipes.js"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        controlBase,
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground h-[var(--ds-density-control-height)] w-full min-w-0 px-[var(--ds-control-padding-inline)] py-[var(--ds-space-1)] text-base outline-none file:inline-flex file:h-[var(--ds-space-7)] file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm",
        controlFocus,
        controlDisabled,
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/35 aria-invalid:border-destructive",
        className
      )}
      {...props} />
  );
});
Input.displayName = "Input";

export { Input }
